import React from 'react';
import { MainLayout } from '../components/MainLayout';
import { useApp } from '../components/AppContext';

export function EventApplicationIntro() {
  const { navigateDirectly, onboardingState, continueToNextStep } = useApp();

  // Check if we're in onboarding flow
  const isOnboardingFlow = onboardingState.currentOnboardingStep > 0;

  const handleContinue = () => {
    if (isOnboardingFlow) {
      // Mark step as completed and move to next onboarding step
      continueToNextStep(2, { eventApplicationIntroCompleted: true });
    } else {
      navigateDirectly('app-event-application');
    }
  };

  return (
    <MainLayout showBack showBottomNav={false}>
      <div className="intro-screen-container">
        <div className="intro-header">
          <div className="intro-icon">
            <span className="text-4xl">📅</span>
          </div>
          <h2 className="text-2xl font-bold text-[var(--ucm-text-dark)] mb-2">
            Apply for the Event
          </h2>
        </div>
        
        <div className="intro-content">
          <h3 className="text-xl font-semibold text-[var(--ucm-text-dark)] mb-6">
            Why we need this information
          </h3>
          
          <div className="intro-reasons">
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">⏰</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Scheduling & Planning
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  Your availability helps us organize trial operations efficiently and ensure proper staffing levels.
                </p>
              </div>
            </div>
            
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">🎯</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Optimal Matching
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  We match participants to dates based on their availability to create the best trial experience.
                </p>
              </div>
            </div>
            
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">📈</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Erfolg der Testphase
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  Ordnungsgemäße Planung gewährleistet einen reibungslosen Ablauf der Testoperationen und liefert wertvolle Erkenntnisse für den Frankfurter Flughafen.
                </p>
              </div>
            </div>
          </div>
          
          <div className="trust-message">
            <p className="text-sm text-[var(--ucm-dark-blue)] leading-relaxed m-0">
              <strong>Flexible participation:</strong> You can apply for multiple dates and update your availability as needed.
            </p>
          </div>
        </div>
        
        <div className="intro-actions">
          <button
            onClick={handleContinue}
            className="w-full h-14 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200"
          >
            View Available Dates
          </button>
        </div>
      </div>
    </MainLayout>
  );
}